import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Divider } from "../../divider";
import { Col, Container, Row } from "../../grid";
import { SocialNavigation } from "../SocialNavigation";
import { FooterSection, Wrapper, StyledFooter } from "./Footer.styles";
import { Copyright } from "../Copyright";
import { RegionSelect } from "../RegionSelect";
import { MetaNavigation } from "../MetaNavigation";
export const Footer = ({ copyright, regionSelect, socialNavigation, metaNavigation, maxContentWidth, toTopButton, }) => {
    const wrapRef = useRef(null);
    const [isWrapped, setIsWrapped] = useState(false);
    const socialNavigationsProps = Object.assign({ items: [], label: "" }, socialNavigation);
    const metaNavigationsProps = Object.assign({ items: [], label: "" }, metaNavigation);
    function handleWrapperChange() {
        if (wrapRef.current !== null) {
            const refHeight = wrapRef.current.getBoundingClientRect().height;
            setIsWrapped(refHeight > 40);
        }
    }
    useEffect(() => {
        handleWrapperChange();
    }, [wrapRef.current]);
    useEffect(() => {
        window.addEventListener("resize", handleWrapperChange);
        return () => window.removeEventListener("resize", handleWrapperChange);
    }, []);
    return (_jsxs(StyledFooter, { children: [_jsx(Divider, {}), _jsx(Container, Object.assign({ maxContentWidth: maxContentWidth }, { children: _jsx(Row, { children: _jsx(Col, { children: _jsxs(Wrapper, { children: [_jsxs(FooterSection, { children: [regionSelect && _jsx(RegionSelect, Object.assign({}, regionSelect)), socialNavigation && (_jsx(SocialNavigation, Object.assign({}, socialNavigationsProps)))] }), _jsxs(FooterSection, Object.assign({ ref: wrapRef, wrapped: isWrapped }, { children: [_jsx(Copyright, Object.assign({ withMarginRight: Boolean(socialNavigation) }, copyright)), metaNavigation && _jsx(MetaNavigation, Object.assign({}, metaNavigationsProps))] }))] }) }) }) })), _jsx(_Fragment, { children: React.isValidElement(toTopButton) ? toTopButton : null })] }));
};
